import {
  DateRangeFilterValueLike,
  dateRangeFilterValueToRange,
} from '@app/components/date-range-selector/date-range-filter-value-to-range';
import { parseAsDateRangeFilter } from '@app/components/date-range-selector/parse-as-date-range-filter';
import { GenericDateRangeFilter } from '@app/core/list-view/base-filters/GenericDateRangeFilter';
import { GenericTextFilter } from '@app/core/list-view/base-filters/GenericTextFilter';
import { createFilter } from '@app/core/list-view/types';
import { parseAsString } from 'nuqs';
import { defineMessage } from 'react-intl';

/**
 * Maps a list date-range filter value to BFF `start` / `end` ISO query params (no CRUD filter strings).
 */
export function composeListDateRangeToApiParams(
  val: DateRangeFilterValueLike | null | undefined,
  timezone?: string,
): Record<string, string> {
  const { from, to } = dateRangeFilterValueToRange(val ?? null, { timezone });

  const out: Record<string, string> = {};

  if (from) {
    out.start = from;
  }

  if (to) {
    out.end = to;
  }

  return out;
}

export const COMPOSE_FILTERS_CONFIG = [
  createFilter({
    name: 'dateRange',
    label: false,
    parser: parseAsDateRangeFilter.withDefault({ preset: 'last7Days' }),
    isPermanent: true,
    component: GenericDateRangeFilter,
    componentProps: {},
    raw: (val, context) =>
      composeListDateRangeToApiParams(val, context?.timezone as string | undefined),
  }),
  createFilter({
    name: 'name',
    label: defineMessage({
      id: 'compose.filters.compositionName',
      defaultMessage: 'Nombre',
    }),
    parser: parseAsString.withDefault(''),
    isPermanent: true,
    component: GenericTextFilter,
    componentProps: {
      sx: {
        width: '22ch',
      },
    },
  }),
];
